import { AppointmentStatus } from '@dreryk/egabinet-appointment-frontend-api';
import { NfzDepartment } from '@dreryk/egabinet-nfz-configuration-frontend-api';
import { PatientReferenceIdentifier } from '@dreryk/egabinet-patient-published-language-api';

export const createNfzDepartmentSelectFilter = (searchText: string | null) => (nfzDepartment: NfzDepartment): boolean =>
   searchText ? nfzDepartment.name.toLowerCase().includes(searchText.toLowerCase()) : true;

export const checkIfPatientIdentifiesWithPESEL = (
   patientReferenceIdentifier: PatientReferenceIdentifier | undefined
): boolean => {
   const externalIdentifier = patientReferenceIdentifier?.findExternalIdentifier();
   if (!externalIdentifier) {
      return false;
   }
   return externalIdentifier.accept<boolean>({
      visitPesel: () => true,
      visitGuardianPesel: () => false,
      visitPassport: () => false,
      visitNationalIdentificationNumber: () => false,
   });
};

export const isAppointmentCancelled = (appointmentStatus: AppointmentStatus): appointmentStatus is 'CANCELLED' => {
   return appointmentStatus === 'CANCELLED';
};
